import React from 'react';

const Navbar = () => (
  <nav style={{ padding: '1rem', backgroundColor: '#333', color: '#fff' }}>
    <h1>Attendance System</h1>
  </nav>
);

export default Navbar;
